<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-toolbar color="transparent" flat height="55">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
          Cuentas por cobrar
          <v-chip class="ml-1" @click="dialogBeta=true, trackEvent('Beta Clicked', { element: 'Chip', feature: 'Receivables' })" color="primary" text-color="white" small>Beta<v-icon dark right small>mdi-creation</v-icon></v-chip>
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="5">
      <v-card color="primary" dark height="280">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 font-weight-medium">Resumen</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-tooltip right min-width="260" max-width="260" transition="scale-transition">
            <template v-slot:activator="{on}">
              <v-progress-linear v-on="on" background-color="orange lighten-4" color="deep-orange lighten-3" height="26" rounded :value="percentages.total_receivables_overdue" style="cursor:pointer;" />
            </template>
            <v-list light>
              <v-list-item class="px-0">
                <v-list-item-title><v-icon class="mt-n1" color="deep-orange lighten-3" left size="22">mdi-square-rounded</v-icon>Vencido</v-list-item-title>
                <v-list-item-subtitle class="text-right text--secondary">{{percentages.total_receivables_overdue}}%</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="px-0">
                <v-list-item-title><v-icon class="mt-n1" color="orange lighten-4" left size="22">mdi-square-rounded</v-icon>Por vencer</v-list-item-title>
                <v-list-item-subtitle class="text-right text--secondary">{{percentages.total_receivables_current_due}}%</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-tooltip>
        </v-card-text>
        <v-card-text class="white--text body-2 indigo darken-1">
          <v-skeleton-loader class="d-inline-block" v-if="loader" type="text" width="200" style="margin-top:6px;" />
          <template v-else><span class="body-1">{{datasets.total_receivables_overdue.value | currency(account.base_currency.id)}}</span> <span class="body-2">{{account.base_currency.id}} vencido</span></template>
        </v-card-text>
        <v-card-text class="white--text body-2 indigo darken-2">
          <v-skeleton-loader class="d-inline-block" v-if="loader" type="text" width="200" style="margin-top:6px;" />
          <template v-else><span class="body-1">{{datasets.total_receivables_current_due.value | currency(account.base_currency.id)}}</span> <span class="body-2">{{account.base_currency.id}} por vencer</span></template>
        </v-card-text>
        <v-card-text class="white--text indigo darken-3">
          <v-skeleton-loader class="d-inline-block" v-if="loader" type="text" width="200" style="margin-top:6px;" />
          <template v-else><span class="body-1 font-weight-medium">{{datasets.total_receivables.value | currency(account.base_currency.id)}}</span> <span class="body-2">{{account.base_currency.id}} total por cobrar</span></template>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="7">
      <v-card height="280">
        <v-toolbar color="transparent" flat height="55">
          <v-list-item-avatar size="36" color="white"><v-icon color="primary" size="24">mdi-transit-connection-variant</v-icon></v-list-item-avatar>
          <v-toolbar-title class="text--secondary body-1 font-weight-medium">Seguimiento y acciones automáticas</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="text--primary">
          Monitorea y configura los pasos que quieres seguir en caso de que tu cliente no pague a tiempo o los cargos en su método de pago fallen.
        </v-card-text>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6">
              <v-subheader class="px-0 no-border"><v-icon color="secondary" left size="18">mdi-email-alert-outline</v-icon>Recordatorios</v-subheader>
              <v-list>
                <v-list-item class="pa-0">
                  <v-list-item-title>
                    <v-btn color="primary" text :ripple="false" :to="{ name: 'ReminderList' }">Recordatorios enviados<v-icon class="mt-1" right small>mdi-arrow-right</v-icon></v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="pa-0">
                  <v-list-item-title>
                    <v-btn color="primary" text :ripple="false" :to="{ name: 'RuleViewSet' }">Reglas de envío de recordatorios<v-icon class="mt-1" right small>mdi-arrow-right</v-icon></v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="6">
              <v-subheader class="px-0 no-border"><v-icon color="secondary" left size="18">mdi-credit-card-sync-outline</v-icon>Cargos automáticos <v-chip class="mx-1" color="defaultGrey" text-color="secondary" x-small>Próximamente</v-chip></v-subheader>
              <v-list>
                <v-list-item class="pa-0">
                  <v-list-item-title>
                    <v-btn color="primary" text :ripple="false" :to="{ name: 'ReminderList' }" disabled>Calendario de reintentos<v-icon class="mt-1" right small>mdi-arrow-right</v-icon></v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="pa-0">
                  <v-list-item-title>
                    <v-btn color="primary" text :ripple="false" :to="{ name: 'RuleViewSet' }" disabled>Reglas de reintentos<v-icon class="mt-1" right small>mdi-arrow-right</v-icon></v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6">
      <metric-table metric="overdue_billing_recovery_breakdown" />
    </v-col>
    <v-col cols="6">
      <metric-table metric="customer_debtor" />
    </v-col>

    <!-- beta program -->
    <v-dialog v-model="dialogBeta" width="800" scrollable persistent no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium"><v-icon color="primary" left small>mdi-creation</v-icon>Funcionalidad Beta</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogBeta=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="background">
          <v-row align="center">
            <v-col>
              <span class="my-4 d-block">Estamos diseñado esta funcionalidad con mucho entusiasmo y nos encanta que la estés probando. Queremos que sepas que tu retroalimentación es muy valiosa para nosotros.</span>
              <span class="my-4 d-block">Esta funcionalidad Beta está disponible de forma gratuita mientras la perfeccionamos, pero queremos ser transparentes acerca de nuestros planes futuros.</span>
              <span class="my-4 d-block">En una próxima actualización, esta característica se convertirá en una parte pagada dentro de nuestros planes de suscripción.</span>
              <span class="my-4 d-block">Si disfrutas usando esta funcionalidad y deseas seguirla utilizando en el futuro, asegúrate de estar atento a las actualizaciones y novedades que compartiremos.</span>
              <span class="mt-4 d-block">¡Gracias por ser parte de nuestro viaje en la construcción  de Piriod! Si tienes alguna pregunta o comentario, no dudes en ponerte en contacto con nuestro centro de ayuda.</span>
            </v-col>
            <v-col cols="5">
              <img :src="require(`@/assets/appImage-betaFeature.svg`)" alt="beta feature image" width="100%">
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end beta program -->

  </v-row>
</template>
<script>
import MetricGraph from '@/components/reports/MetricGraph'
import MetricKpi from '@/components/reports/MetricKpi'
import MetricTable from '@/components/reports/MetricTable'

import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  components: {
    MetricGraph,
    MetricKpi,
    MetricTable
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    datasets: {
      total_receivables_current_due: {},
      total_receivables_overdue: {},
      total_receivables: {}
    },
    dialogBeta: false,
    loader: false,
    percentages: {
      total_receivables_current_due: 0,
      total_receivables_overdue: 0
    }
  }),
  created () {
    this.loader = true

    Promise.all([
      this.retrieveMetric('total_receivables_current_due'),
      this.retrieveMetric('total_receivables_overdue'),
      this.retrieveMetric('total_receivables')
    ])
    .then(() => {
      Object.keys(this.percentages).forEach(key => {
        const dataset = this.datasets[key]

        if (dataset.value && dataset.value > 0) {
          this.percentages[key] = ((dataset.value / this.datasets.total_receivables.value) * 100).toFixed(2)
        }
      })
    })
    .finally(() => {
      setTimeout(() => {
        this.loader = false
      }, 800)
    })
  },
  methods: {
    async retrieveMetric (name) {
      const dataset = await this.$store.dispatch('analytics/GET', {
        resource: `metrics/${name}/kpi`,
        query: {
          interval: 'monthly',
          comparative: 'this_v_last'
        }
      })

      this.datasets[name] = dataset.data
    }
  }
}
</script>